import Vue from 'vue/dist/vue.esm'
import template from './classroom_select_template.slim'
import withScrollToTop from '../../../mixins/with_scroll_to_top.js'

Vue.component('classroom-select', {
  mixins: [template, withScrollToTop],
  props: ['value', 'classroom_options', 'errors', 'required', 'label_text'],
  data() {
    return {
      hasFocus: false,
    }
  },
  methods: {
    updateClassroom(value) {
      this.$emit('input', value)
    },
    toggleFocus(e) {
      e.stopPropagation()
      e.preventDefault()
      if (this.hasFocus) {
        $('body').focus()
      } else {
        this.$refs.classroomSelect.$el.focus()
      }
      this.hasFocus = !this.hasFocus
    },
  },
})
